export default __webpack_public_path__ + "static/media/edit-tab.4c41024b.svg";